// extracted by mini-css-extract-plugin
export default {"primaryResult":"styles_primaryResult__XdJUY","secondaryResult":"styles_secondaryResult__KPdOx"};